import { writable } from 'svelte/store';
import { Device, mapWidthToDevice, responsive$ } from './../responsive';

var checkIsMobile = function checkIsMobile(device) {
  return device !== Device.Desktop;
};

export var IsMobile = writable(checkIsMobile(mapWidthToDevice()));
responsive$.subscribe(function (device) {
  return IsMobile.set(checkIsMobile(device));
});